<template>
    <default-modal
        :show="showModal"
        :closeOnClickModal="false"
        @close="closeModal"
    >

        <el-form :model="form" :rules="rules" ref="form">
            <div class="gcmcn-inputs-container">
                <div class="flex-basis-5">
                    <el-form-item class="gcmcn-form-input" prop="end_date">
                        <div class="gcmcn-form-label">End date</div>
                        <el-date-picker
                            v-model="form.end_date"
                            popper-class="gcmcn-popper"
                            type="date"
                            size="mini"
                            placeholder="Select a date"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="flex-basis-5">
                    <el-form-item class="gcmcn-form-input" prop="end_time">
                        <div class="gcmcn-form-label">At</div>
                        <ns-time-picker
                            v-model="form.end_time"
                            :max-hour-value="23"
                            :display-seconds="false"
                            :display-digital-clock="true"
                        ></ns-time-picker>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="extendFeed"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import NsTimePicker from 'fundation-app-vuejs/src/components/partials/ns-time-picker.vue';

export default {

    components: {
        DefaultModal,
        NsTimePicker,
    },

    props: {

    },

    data (){
        const checkTime = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please input the time'));
            }
            if(this.form.end_date){
                let endTimeSplitted = value.split(':');
                let end_date = moment(this.form.end_date);
                let extendedEndDate = moment.utc().set({
                    month: end_date.month(),
                    day: end_date.day(),
                    year: end_date.year(),
                    hours: endTimeSplitted[0],
                    minutes: endTimeSplitted[1],
                    seconds: 0,
                });
                if(extendedEndDate.isBefore(moment.utc(this.feed.confirmed_end_date))){
                    callback(new Error('Extended end date c\'ant be before current feed end date.'));
                }
                callback();
            }
        };
        return {
            showModal: false,
            form: {
                end_date: '',
                end_time: '',
            },
            rules: {
                end_date: [{ type: 'date', required: true, message: 'Start date is required' }],
                end_time: [{ validator: checkTime }],
            },
            loading: false,
            stopFeedTimeoutId: null,
            feed: null,
            pickerOptions: {
                disabledDate(time) {
                    return moment(time).isBefore(moment().subtract(1, 'days'));
                },
            },
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (feed){
            this.$set(this, 'feed', feed);
            this.$set(
                this.form,
                'end_time',
                moment
                .utc(this.feed.confirmed_end_date)
                .format('HH:mm')
            )
            this.$set(
                this.form,
                'end_date',
                new Date(
                    moment(this.feed.confirmed_end_date)
                    .set({hours: 0, minutes: 0, seconds: 0})
                    .format()
                )
            );
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.form.start_date = '';
            this.form.start_time = '';
            this.$set(this, 'feed', null);
        },

        extendFeed (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;

                    let form = JSON.parse(JSON.stringify(this.form));
                    form.end_time = moment.utc(this.form.end_time, 'HH:mm:ss').format('HH:mm:ss');
                    let endTimeSplitted = form.end_time.split(':');
                    let end_date = moment(form.end_date).add({
                        hours: endTimeSplitted[0],
                        minutes: endTimeSplitted[1],
                        seconds: endTimeSplitted[2],
                    }).format('YYYY-MM-DDTHH:mm:ss');

                    this.$store.dispatch('createItem', {
                        item: {
                            action: 'EXTEND',
                            feed_uid: this.feed.uid,
                            end_date: end_date,
                        },
                        model: 'feedModificationRequests',
                        url: this.$store.state.api.meta.listModels.feedModificationRequests.url
                    }).then((res) => {
                        this.$emit('watch-feed-modification-request', res.url);
                        this.showModal = false;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/modal-extend-feed.vue